import React from "react"
import { MdClose } from "react-icons/md"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { IconButton, Modal } from "components"
import HeldOrderTableRow from "./HeldOrderTableRow"
import classes from "./HeldOrdersListModal.module.scss"

const HeldOrdersListModal = props => {
  const {
    openRetrievModal,
    setOpenRetrievModal
  } = props

  const [t] = useTranslation()

  const heldOrders = useSelector(state => state.heldOrders)

  const serviceTypeName =
    useSelector(state =>
      state.systemSettings.serviceTypeName
    )

  return (
    <Modal
      size="lg"
      show={openRetrievModal}
      onHide={() => setOpenRetrievModal(false)}
    >
      <div className={classes["container"]}>
        <div className={classes["topBar"]}>
          <IconButton
            icon={MdClose}
            size={20}
            onClick={() => setOpenRetrievModal(false)}
          />
        </div>
        <table className={classes["table"]}>
          <thead>
            <tr className={classes["header"]}>
              <th className={classes["headerItem1"]}>
                {t("تاریخ_ایجاد")}
              </th>
              <th className={classes["headerItem2"]}>
                {t("آیتم_ها")}
              </th>
              <th className={classes["headerItem3"]}>
                {t("نوع_تحویل")}
              </th>
              {
                serviceTypeName === "restaurant" &&
                <th className={classes["headerItem4"]}>
                  {t("شماره_میز")}
                </th>
              }
              <th className={clsx(classes["headerItem5"], classes["center"])}>
                {t("عملیات")}
              </th>
            </tr>
          </thead>

          <tbody className={classes["list"]}>
            {heldOrders.map(heldOrder =>
              <HeldOrderTableRow
                key={heldOrder._id}
                heldOrder={heldOrder}
                setOpenRetrievModal={setOpenRetrievModal}
              />
            )}
          </tbody>
        </table>
      </div>
    </Modal>
  )
}

export default HeldOrdersListModal